enum MemberGroups {
  defaultUser = "defaultUser",
  castingDirector = "castingDirector",
  searchOnlyCD = "castingDirector:searchOnlyCastingDirector",
  castingBBC = "castingDirectorBBC",
  performer = "performer",
  agent = "agent",
  yPerformer = "performer:youngPerformer",
  graduatePerformer = "performer:graduate",
  anonymous = "anonymous",
}

export default MemberGroups;
